import React, { useState, useEffect } from 'react'

const WebsiteDevelopment = () => {
    const [activeService, setActiveService] = useState('custom-web');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">BUILD YOUR DIGITAL PRESENCE</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    Website <span className="breadcrumb-highlight">Development</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Website Development Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Professional Website </span> Development Services
                                </h2>
                                <p className="ai-driven-description">
                                    Your website is your digital storefront and often the first impression customers have of your brand. CLOUD MIND X delivers stunning, high-performance websites that captivate visitors, drive conversions, and establish your online authority. From corporate websites to complex web platforms, we create digital experiences that elevate your business and engage your audience effectively.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO AN EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
                                    alt="Website Development Services"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With extensive experience in web development and a team of 50+ creative professionals,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> provides comprehensive website development services to help businesses<br />
                                    establish powerful online presences that drive growth and deliver exceptional results.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="custom-web">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Custom Website Development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="ecommerce">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">E-commerce Solutions</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="cms">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">CMS Development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="frontend">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Frontend Development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="backend">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Backend Development</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="website-maintenance">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Website Maintenance & Optimization</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* Custom Website Development */}
                                <div className="service-detail active" id="custom-web">
                                    <h3 className="service-detail-title">Custom Website Development</h3>
                                    <p className="service-detail-description">
                                        Build bespoke websites tailored to your unique business requirements and brand identity. We create fully customized solutions from scratch, incorporating advanced features, interactive elements, and scalable architectures that perfectly align with your vision and business objectives, ensuring you stand out in the digital landscape.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Custom Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* E-commerce Solutions */}
                                <div className="service-detail" id="ecommerce">
                                    <h3 className="service-detail-title">E-commerce Solutions</h3>
                                    <p className="service-detail-description">
                                        Launch and grow your online store with powerful e-commerce platforms built for conversions. We develop feature-rich online shops with secure payment gateways, inventory management, order tracking, customer accounts, and seamless checkout experiences. Our solutions scale from startups to enterprise-level marketplaces.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request E-commerce Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* CMS Development */}
                                <div className="service-detail" id="cms">
                                    <h3 className="service-detail-title">CMS Development</h3>
                                    <p className="service-detail-description">
                                        Empower your team to manage website content effortlessly with custom Content Management Systems. We implement and customize popular CMS platforms like WordPress, Drupal, and Joomla, or build headless CMS solutions that provide flexibility, ease of use, and complete control over your digital content.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request CMS Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Frontend Development */}
                                <div className="service-detail" id="frontend">
                                    <h3 className="service-detail-title">Frontend Development</h3>
                                    <p className="service-detail-description">
                                        Create visually stunning and highly interactive user interfaces using modern frontend technologies like React, Vue.js, Angular, and Next.js. Our frontend development focuses on responsive design, smooth animations, optimal performance, cross-browser compatibility, and accessibility to deliver exceptional user experiences.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Frontend Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Backend Development */}
                                <div className="service-detail" id="backend">
                                    <h3 className="service-detail-title">Backend Development</h3>
                                    <p className="service-detail-description">
                                        Build robust, secure, and scalable server-side infrastructure that powers your web applications. We develop backend systems using Node.js, Python, PHP, Ruby, and Java, implementing RESTful APIs, database architecture, authentication systems, and cloud integrations that ensure reliability and peak performance.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Backend Development</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Website Maintenance */}
                                <div className="service-detail" id="website-maintenance">
                                    <h3 className="service-detail-title">Website Maintenance & Optimization</h3>
                                    <p className="service-detail-description">
                                        Keep your website secure, fast, and up-to-date with comprehensive maintenance services. We provide regular security updates, performance optimization, content updates, bug fixes, backup management, and SEO enhancements to ensure your website continues to perform at its best and remains competitive.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Maintenance Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Website Development Capabilities Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">WEB EXPERTISE</span>
                                <h2 className="section-title-dark">Website Development Technologies & Solutions We Excel In</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X masters the latest web technologies and frameworks to create modern, high-performing websites that drive business success. Our expertise covers <strong>full-stack development, modern frameworks, and scalable architectures</strong> across diverse industries including retail, healthcare, finance, education, real estate, hospitality, and professional services.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* Responsive Web Design */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="6" y="10" width="36" height="24" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="14" y="20" width="12" height="16" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M6 16H42" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Responsive Web Design</h4>
                                <p className="capability-description">
                                    Create websites that look stunning and function flawlessly across all devices and screen sizes. Our responsive design approach ensures optimal viewing experiences on desktops, tablets, and smartphones, using fluid grids, flexible images, and modern CSS techniques for seamless adaptability and user engagement.
                                </p>
                            </div>
                        </div>

                        {/* Single Page Applications */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="10" width="28" height="28" rx="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 20L24 26L30 20" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="24" cy="24" r="8" stroke="#4187f7" strokeWidth="2" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Single Page Applications (SPA)</h4>
                                <p className="capability-description">
                                    Build lightning-fast single page applications that deliver app-like experiences in the browser. Using React, Vue.js, or Angular, we create dynamic SPAs with instant page transitions, real-time updates, and offline capabilities that enhance user engagement and provide smooth, uninterrupted interactions.
                                </p>
                            </div>
                        </div>

                        {/* WordPress Development */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="16" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 8V24L34 34" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="24" cy="24" r="3" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">WordPress Development</h4>
                                <p className="capability-description">
                                    Leverage the world's most popular CMS with custom WordPress solutions tailored to your needs. We build custom themes, develop plugins, optimize performance, and create enterprise-level WordPress websites that are secure, scalable, and easy to manage, empowering you to control your content effortlessly.
                                </p>
                            </div>
                        </div>

                        {/* Shopify & WooCommerce */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16 14L12 38H36L32 14H16Z" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M16 14L18 10H30L32 14" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="20" cy="24" r="2" fill="#4187f7" />
                                        <circle cx="28" cy="24" r="2" fill="#4187f7" />
                                        <path d="M20 30H28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Shopify & WooCommerce</h4>
                                <p className="capability-description">
                                    Launch successful online stores with Shopify or WooCommerce platforms optimized for conversions. We customize themes, integrate payment gateways, implement inventory systems, and add advanced features like subscriptions, personalization, and analytics to maximize your e-commerce revenue and customer satisfaction.
                                </p>
                            </div>
                        </div>

                        {/* API Integration */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="14" cy="24" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="34" cy="24" r="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M20 24H28" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M14 18V12M14 36V30M34 18V12M34 36V30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">API Integration & Development</h4>
                                <p className="capability-description">
                                    Connect your website with third-party services and build custom APIs for seamless data exchange. We integrate payment processors, CRM systems, marketing tools, social media platforms, and develop RESTful and GraphQL APIs that enable your website to communicate efficiently with other systems.
                                </p>
                            </div>
                        </div>

                        {/* Web Performance Optimization */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="16" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 12L27 22H37L29 28L32 38L24 32L16 38L19 28L11 22H21L24 12Z" fill="#4187f7" opacity="0.3" />
                                        <path d="M24 12L27 22H37L29 28L32 38L24 32L16 38L19 28L11 22H21L24 12Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Web Performance Optimization</h4>
                                <p className="capability-description">
                                    Achieve lightning-fast loading speeds and superior performance with our optimization techniques. We implement code minification, image optimization, caching strategies, lazy loading, CDN integration, and Core Web Vitals improvements to ensure your website ranks higher in search results and delights users.
                                </p>
                            </div>
                        </div>

                        {/* Web Security */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 8L38 14V24C38 32 32 38 24 42C16 38 10 32 10 24V14L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M24 18V26M24 30V32" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Web Security & SSL</h4>
                                <p className="capability-description">
                                    Protect your website and user data with enterprise-grade security measures. We implement SSL certificates, secure authentication, data encryption, DDoS protection, malware scanning, regular security audits, and compliance with GDPR and other regulations to safeguard your digital assets and build user trust.
                                </p>
                            </div>
                        </div>

                        {/* SEO Optimization */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="20" cy="20" r="10" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M28 28L38 38" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M15 20H25M20 15V25" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">SEO Optimization</h4>
                                <p className="capability-description">
                                    Build websites that rank high in search engines and attract organic traffic. We implement SEO best practices including semantic HTML, structured data, meta optimization, XML sitemaps, mobile-first design, and technical SEO fundamentals to maximize your visibility and drive qualified leads to your business.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WebsiteDevelopment
